import { render, staticRenderFns } from "./game-hot.vue?vue&type=template&id=39709c93&"
import script from "./game-hot.vue?vue&type=script&lang=js&"
export * from "./game-hot.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports